import {WebStat} from '@miro-site/stats'

export interface EventHubMethods {
  identify: (id: string) => void
  page: () => void
  track: (eventName: string, properties: Record<string, unknown> | string) => void
}

let eventHub: EventHubMethods = null

const getEventHub = () => {
  // skip server side imports
  if (typeof window === 'undefined') {
    return null
  }

  if (!eventHub) {
    const params = {
      apiHost: `${process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT}/v1`,
      apiKey: process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH,
    }

    const handler = WebStat.createStatHandler({
      apiHost: params.apiHost,
      library: 'miro-site/analytics',
      version: '0.0.1',
      addCommonStatParams: params => ({
        ...params,
      }),
      sendError: (err, extra) => console.error(err, extra),
    })

    const methods = {
      identify: (id: string) => {
        WebStat.identify(handler, params.apiKey, {id, name: '', email: ''})
      },
      page: () => {
        WebStat.page(handler, params.apiKey)
      },
      track: (eventName, properties) => {
        let cleanProps = properties

        // "properties" can be passed as a string
        if (typeof properties === 'string') {
          const trimmedStringProp = properties.trim()

          if (trimmedStringProp.length > 0) {
            cleanProps = {trimmedStringProp}
          }
        }

        WebStat.track(handler, params.apiKey, eventName, cleanProps)
      },
    }

    if (!window.analytics) {
      window.analytics = methods
    }

    eventHub = methods
  }

  return eventHub
}

export default getEventHub()
